import selectors from "./selectors";

export default (state, action, lastGlobalState) => {
  const todayDate = selectors.getTodayDateFromActionOrLastState(action, lastGlobalState);
  if (todayDate && (!state || todayDate.timestamp !== state.timestamp)) {
    return todayDate;
  }
  return state;
};
